module.exports = __webpack_public_path__ + "img/map-street.88b87856.jpg";